import { firebase } from '../firebase';

class CacheManager {
  lessons = {};

  lessonSave = (lessonId, data) => {
    const currentUser = firebase.auth().currentUser;
    if (!currentUser) return;

    this.lessons[currentUser.uid] = {
      ...this.lessons[currentUser.uid],
      [lessonId]: data,
    };
  };

  lessonOpen = (lessonId) => {
    const currentUser = firebase.auth().currentUser;
    if (!currentUser) return;

    return this.lessons[currentUser.uid]?.[lessonId];
  };

  lessonRemove = (lessonId) => {
    const currentUser = firebase.auth().currentUser;
    if (!currentUser) return;

    this.lessons[currentUser.uid] = {
      ...this.lessons[currentUser.uid],
      [lessonId]: undefined,
    };
  };
}

const cacheManager = new CacheManager();

export default cacheManager;
